import _defineProperty from '@babel/runtime/helpers/defineProperty';

var MODEL_S = 'MODEL_S';
var MODEL_X = 'MODEL_X';
var MODEL_Y = 'MODEL_Y';
var MODEL_3 = 'MODEL_3';
var CYBERTRUCK = 'CYBERTRUCK';
var ROADSTER_RD = 'ROADSTER_RD';
var ROADSTER_MT = 'ROADSTER_MT';
var SEMI = 'SEMI';
var MODEL_CODES = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MODEL_S, 'ms'), MODEL_3, 'm3'), MODEL_X, 'mx'), MODEL_Y, 'my'), ROADSTER_RD, 'rd'), ROADSTER_MT, 'mt'), CYBERTRUCK, 'ct'), SEMI, 'ts');

export { CYBERTRUCK, MODEL_3, MODEL_CODES, MODEL_S, MODEL_X, MODEL_Y, ROADSTER_MT, ROADSTER_RD, SEMI };
